import * as React from 'react';
import Context from '../State/Context';
import { Input } from './MlrForm';
import Total from './Total';

interface IControlOther {
    value: number
    name: string
    total?: string
    isParentEnabled: boolean
    onChangeName: (value: string) => void
    onChangeValue: (value: number) => void
    placeholder: string
    rowNumber: number
}

export const ControlOther = ({ value, name, total, onChangeName, onChangeValue, isParentEnabled, placeholder, rowNumber }: IControlOther) => (
    <Context.Consumer>
        {() => {
            const onChangeText = (e: React.FormEvent<HTMLInputElement>) => onChangeName(e.currentTarget.value);
            const onChangeNumber = (e: React.FormEvent<HTMLInputElement>) => onChangeValue(Number(e.currentTarget.value));

            return (
                <React.Fragment>
                    <Input style={{ msGridRow: rowNumber }} type="text" value={name} onChange={onChangeText} disabled={!isParentEnabled} placeholder={placeholder}/>
                    <Input style={{ msGridRow: rowNumber }} type="number" value={value} onChange={onChangeNumber} disabled={!isParentEnabled}/>
                    {total && <Total enabled={isParentEnabled}>{total}</Total>}
                </React.Fragment>
            )
        }}
    </Context.Consumer>
);


// WEBPACK FOOTER //
// ./src/Components/ControlOther.tsx